<template>
  <div class="auth-placeholder">
    <div class="auth-panel">
      <h1>Reset Password</h1>
      <p>Password reset links are not supported by the backend yet. Contact an administrator for help.</p>
      <router-link to="/login">Back to login</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResetPassword'
};
</script>

<style scoped>
.auth-placeholder {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #f8fafc;
}

.auth-panel {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 28px;
  text-align: left;
}

h1 {
  margin: 0 0 8px;
  font-size: 24px;
  color: #0f172a;
}

p {
  color: #475569;
  line-height: 1.5;
}

a {
  color: #2563eb;
  font-weight: 700;
  text-decoration: none;
}
</style>
